module.exports = __webpack_public_path__ + "svgs/no-card.f50b40a7.svg";